// --- Exporting all reducers
import spinner from "./spinner/reducer";
import auth from "./auth/reducer";
import { users } from "./users/reducer";
import { pmxDeliveries } from "./pmxDeliveries/reducer";
import { pmxPricesAndDates } from "./pmxPricesAndDates/reducer";
import { tapJobs } from "./tapJobs/reducer";
import { updateEngine } from "./updateEngine/reducer";
import { tprExceptions } from "./tprExceptions/reducer";
import { rateCards } from "./rateCards/reducer";
import { licensingJobs } from "./licensingJobs/reducer";
import { offers } from "./offers/reducer.js";
import { offerHistory } from "./offerHistory/reducer.js";
import { windows } from "./windows/reducer.js";
import { ppt } from "./ppt/reducer.js";

export const tapReducers = {
  spinner,
  auth,
  pmxPricesAndDates,
  pmxDeliveries,
  users,
  tapJobs,
  licensingJobs,
  updateEngine,
  tprExceptions,
  rateCards,
  offers,
  offerHistory,
  windows,
  ppt,
};
